"use client"

import styled from "@emotion/styled"
import { useIsDesktop } from "ui"
import Gallery from "../Gallery"

const StyledDrawerGallery = styled.div`
  display: flex;
  width: 100%;
`

type Props = {
  images?: string[]
  locale: string
  expandIcon?: boolean
  rentProjectInterestedNum?: number
}

const DrawerGallery = ({ images, locale, expandIcon, rentProjectInterestedNum }: Props) => {
  const isDesktop = useIsDesktop()
  const galleryImages = images ?? []
  return (
    <StyledDrawerGallery>
      {galleryImages?.length > 0 && (
        <Gallery
          locale={locale}
          gallery={galleryImages?.map((image) => ({
            imageOrVideoSelectorMobaile: image,
            imageOrVideoSelsctor: image,
          }))}
          swiperContainerProps={{
            padding: 33,
            withoutPadding: !isDesktop,
            width: 1240,
          }}
          style={{
            padding: 0,
          }}
          expandIcon={expandIcon}
          newStylePagination
          slideHeight={264}
          mobileSlideHeight={226}
          rentProjectInterestedNum={rentProjectInterestedNum}
        />
      )}
    </StyledDrawerGallery>
  )
}
export default DrawerGallery
